import { SET_ERROR_ALERT } from '../types';

const appReducer = (state, action) => {
  switch (action.type) {
    case SET_ERROR_ALERT:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default appReducer;
